import { createContext } from 'react'
import { InterpreterFrom } from 'xstate'

import type { machine } from './state/machine-rewards-onboarding'

export const RewardsOnboardingServiceContext = createContext({} as InterpreterFrom<typeof machine>)
